<template>
  <div class="compete-round">
    <div class="h-tabs animate__animated animate__fadeInUp" id="coupete-round">
      <div class="h-tab-items">
        <div
          class="tab-item"
          :class="{ actived: round.name === activeTab }"
          v-for="round in rounds"
          :key="round.name"
          @click="activeTab = round.name"
        >
          <div>
            {{ round.label }}
            <span class="round-now" v-if="round.active"
              ><span class="icon-wrap"
                ><h-icon name="fireball" style="color: #ffd700"></h-icon></span
              >进行中</span
            >
            <template v-else>
              <span v-if="round.ended" class="ended">已结束</span>
              <span :class="round.disabled ? 'waiting' : 'time'" v-else>{{
                round.time
              }}</span>
            </template>
          </div>
          <div>{{ round.title }}</div>
        </div>
      </div>
      <div class="h-tab-content">
        <transition name="h-tabs" mode="out-in">
          <div>
            <div class="round-desc">
              {{ introduction }}
            </div>
            <RoundComponent :checkpoints="checkpoints" :round="activeTab" />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { getLevelList } from '@/api/competition'
import RoundComponent from './components/roundComponent'
const round1WillPic = require('@/assets/competition/not-start-2-2x.png') // 敬请期待图片【round1】
const fininshPic = require('@/assets/competition/round1-finish-2x.png') // 结束图片【round1、】
const round2_1_lightPic = require('@/assets/financialCompetition/round1-2x.png') // 敬请期待、进行中图片【round2-level1】
const round2_1_grayPic = require('@/assets/financialCompetition/round1-finish-2x.png') // 结束图片【round2-level1】
const round2_2_lightPic = require('@/assets/financialCompetition/round2-2x.png') // 敬请期待、进行中图片【round2-level2】
const round2_2_grayPic = require('@/assets/financialCompetition/round2-finish-2x.png') // 结束图片【round2-level2】 待补充
const round2_3_lightPic = require('@/assets/financialCompetition/round3-2x.png') // 敬请期待、进行中图片【round2-level3】
const round2_3_grayPic = require('@/assets/financialCompetition/round3-finish-2x.png') // 结束图片【round2-level3】
const round2_4_lightPic = require('@/assets/financialCompetition/round4-2x.png') // 敬请期待、进行中图片【round2-level4】
const round2_4_grayPic = require('@/assets/financialCompetition/round4-finish-2x.png') // 结束图片【round2-level4】
const statePicMap = {
  '1-1-0': round1WillPic,
  '1-1-2': fininshPic,
  '2-1-0': round2_1_lightPic,
  '2-1-1': round2_1_lightPic,
  '2-1-2': round2_1_grayPic,
  '2-2-0': round2_2_lightPic,
  '2-2-1': round2_2_lightPic,
  '2-2-2': round2_2_grayPic,
  '2-3-0': round2_3_lightPic,
  '2-3-1': round2_3_lightPic,
  '2-3-2': round2_3_grayPic,
  '2-4-0': round2_4_lightPic,
  '2-4-1': round2_4_lightPic,
  '2-4-2': round2_4_grayPic
}
export default {
  name: 'CompeteRound',
  props: {},
  components: {
    RoundComponent
  },
  data() {
    return {
      round1Levels: window.financialCompetitionResource.round1Levels, // round1关卡
      round2Levels: window.financialCompetitionResource.round2Levels, // round1关卡
      activeTab: window.financialCompetitionResource.competitionInfo.activeTab, // 当前页面激活的赛段
      rounds: window.financialCompetitionResource.competitionInfo.rounds, // 赛段tab信息
      round1InitialArr: [], // round1赛段最初列表
      round2InitialArr: [] // round2赛段最初列表
    }
  },
  computed: {
    introduction() {
      if (this.activeTab === 'round1') {
        return this.rounds[0].introduction
      }
      if (this.activeTab === 'round2') {
        return this.rounds[1].introduction
      }
    },
    checkpoints() {
      if (this.activeTab === 'round1') {
        return this.round1InitialArr
      }
      if (this.activeTab === 'round2') {
        return this.round2InitialArr
      }
    }
  },
  created() {
    this.getLevelList()
  },
  mounted() {},
  methods: {
    async getLevelList() {
      const res = await getLevelList()
      if (res && res.length) {
        const arr1 = []
        const arr2 = []
        res.forEach((item) => {
          if (this.round1Levels.includes(String(item.level_id))) {
            arr1.push(item)
          }
          if (this.round2Levels.includes(String(item.level_id))) {
            arr2.push(item)
          }
        })
        this.round1InitialArr = JSON.parse(JSON.stringify(arr1))
        this.round2InitialArr = JSON.parse(JSON.stringify(arr2))
        this.setRoundList(this.round1InitialArr, 1)
        this.setRoundList(this.round2InitialArr, 2)
      }
    },
    setRoundList(arr, round) {
      arr.forEach((item, index) => {
        const { level_state, level_desc, start_date, end_date, level_id } = item
        item.time = []
        item.finished = level_state === '2'
        // 日期不展示年
        const dateStartArr = start_date.split('-')
        dateStartArr.shift()
        item.time[0] = dateStartArr.join('.')
        const dateEndArr = end_date.split('-')
        dateEndArr.shift()
        item.time[1] = dateEndArr.join('.')
        item.descriptions = level_desc.split('\n')
        item.img = statePicMap[`${round}-${index + 1}-${level_state}`]
        if (level_state === '1') {
          item.doing = true // 进行中关卡
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#coupete-round {
  opacity: 0;
}
.compete-round {
  max-width: 1200px;
  height: 571px;
  border-radius: 25px;
  margin: 52px auto 62px;
  background: #fff;
  box-shadow: 0px 14px 40px 0px rgba(230, 230, 230, 1);
  .round-now {
    margin: 0 0 8px 6px;
    font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
      Verdana, 'PingFang SC';
    display: inline-block;
    height: 14px;
    font-size: 10px;
    line-height: 14px;
    color: #fff;
    position: relative;
    background-image: linear-gradient(42deg, #ff3030 0%, #8046f2 100%);
    box-shadow: 0 4px 8px 0 rgba(48, 60, 250, 0.25);
    border-radius: 7px;
    padding: 0 5px 0 21px;
    font-weight: normal;
    .icon-wrap {
      position: absolute;
      left: -2px;
      bottom: 0;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      background-color: #ccc;
      background-image: linear-gradient(222deg, #fe9807 0%, #ff2f2f 53%);
      box-shadow: 1px 1px 3px 0 rgba(240, 19, 19, 0.42);
    }
  }
}
.h-tabs {
  width: 100%;
  .h-tab-items {
    width: inherit;
    padding: 0px 32px;
    box-sizing: border-box;
    border-bottom: solid 1px #d9d9d9;
  }
  .tab-item {
    display: inline-flex;
    flex-direction: column;
    color: #333;
    font-size: 30px;
    line-height: 42px;
    position: relative;
    box-sizing: border-box;
    padding: 24px 0 12px 0;
    &:hover {
      cursor: pointer;
      color: #666;
    }
    &.actived {
      color: #000;
      font-weight: bold;
      &:after {
        width: 80px;
        left: 0;
      }
    }
    &:after {
      content: '';
      display: inline-block;
      width: 0;
      background-color: #3060ff;
      background-image: linear-gradient(42deg, #3060ff 0%, #0ff4f1 100%);
      height: 6px;
      position: absolute;
      top: 98%;
      left: 40px;
      margin-top: -2px;
      transition: all 0.3s;
      max-width: 100%;
    }
    &:not(:first-child) {
      margin-left: 150px;
    }
    > div {
      &:first-child {
        font-family: 'Alibaba-PuHuiTi-H', Arial, 'Microsoft Yahei', sans-serif,
          Verdana, 'PingFang SC';
        .time {
          font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
            Verdana, 'PingFang SC';
          font-size: 20px;
          color: #333333;
          line-height: 42px;
          margin-left: 16px;
        }
        .ended {
          padding: 0 10px;
          height: 23px;
          background: #ededed;
          border-radius: 2px;
          font-size: 14px;
          color: #b2b2b2;
          text-align: center;
          line-height: 23px;
          display: inline-block;
          position: relative;
          top: -6px;
        }
        .waiting {
          display: inline-block;
          padding: 0 6px;
          height: 18px;
          line-height: 18px;
          align-items: center;
          background-color: rgba(0, 0, 0, 0.04);
          border: 1px solid rgba(0, 0, 0, 0.15);
          border-radius: 2px;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.25);
          margin-left: 10px;
        }
      }
      &:last-child {
        font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
          Verdana, 'PingFang SC';
      }
    }
  }
}
.h-tab-content {
  width: inherit;
  padding: 0 32px;
  box-sizing: border-box;
  position: relative;
  .round-desc {
    font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
      Verdana, 'PingFang SC';
    font-size: 16px;
    line-height: 24px;
    color: #3e3e3e;
    margin-top: 16px;
    height: 24px;
  }
}
.h-tabs-enter {
  transform: translateX(100%);
}
.h-tabs-leave-to {
  transform: translateX(-100%);
}
.h-tabs-enter-to,
.h-tabs-leave {
  transform: translateX(0%);
}
.h-tabs-enter-active,
.h-tabs-leave-active {
  transition: transform 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/competeRound/competeRound.vue